/*
 * @description 获取文本的宽度
 * @param param.text - 目标文本
 * @param param.font - 字体
 * */
const getTextWidth = (param: { text: string; font: string }) => {
    const canvas = document.createElement('canvas')

    canvas.style.position = 'fixed'
    canvas.style.left = '-10000px'

    document.body.appendChild(canvas) // 注意：必须插入到文档中，否则不准，暂未知什么属性影响的

    const ctx = canvas.getContext('2d')

    if(ctx){
        ctx.font = `${param.font} -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`
    }

    setTimeout(() => {
        canvas.parentNode?.removeChild?.(canvas)
    })

    return ctx ? ctx.measureText(param.text).width : 0
}

/**
 * @description 获取溢出文本
 * @param param.text - 目标文本
 * @param param.font - 字体
 * @param param.width - 宽度
 * @param param.dotText - 省略符号
 */
export const getOverflowEllipsisText = ({ text, font, width, dotText = '...' } : { text: string, font: string, width: number, dotText: string }) => {
    const items = text?.split('') || []
    const itemWidthList: Array<number> = items.map((v: string) => getTextWidth({ text: v, font }))
    const dotWidth = getTextWidth({ text: dotText, font })

    const sumWidth = itemWidthList.reduce((t: number, c: any) => {
        return t + c
    }, 0)
    
    // 溢出
    if(sumWidth > width){
        let sumWidth = 0
        let sumStr = ''

        for(let i = 0; i < itemWidthList.length; i++){
            const itemWidth = itemWidthList[i]
            const itemStr = items[i]

            const isOverflow = sumWidth + itemWidth + dotWidth > width

            if(isOverflow){
                return sumStr + dotText
            } else {
                sumWidth += itemWidth
                sumStr += itemStr
            }            
            
        }
    }

    return text
}

export default getTextWidth